import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog } from "@headlessui/react";
import LoginBackground from "../assets/LoginBackground.png";
import { useAuth } from "../context/authContext";
import api from "../api";
import CustomTextInput from "../components/CustomTextInput";
import aquilaLogo from "../assets/aquilaLogo.svg";
import Modal from "../components/Modal";

const LoginPage = () => {
  const [openForgotPassword, setOpenForgotPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();
  const auth = useAuth();

  /*const recoverPassword = async () => {
    try {
      await api.reset_password.sendEmail(email || "");
      setOpenForgotPassword(false);
    } catch (error) {
      console.log(error);
      setErrorMessage("Error al recuperar la contraseña. Intenta nuevamente.");
    }
  };*/

  /*const forgotPassword = (
    <>
      <div>
        <div className="text-center">
          <Dialog.Title
            as="h3"
            className="text-lg leading-6 font-semibold text-gray-900"
          >
            Recuperar Contraseña
          </Dialog.Title>
          <div className="mt-2 w-full">
            <label
              htmlFor="email"
              className="text-sm font-medium text-gray-700"
            >
              Correo Electrónico
            </label>
            <div className="relative w-2/3 rounded-md mx-auto shadow-sm">
              <input
                type="email"
                name="email"
                onChange={(e) => setEmail(e.target.value)}
                id="email"
                className="block mt-1 w-full h-8 pr-10 sm:text-sm border pl-1 border-gray-300 rounded-md"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
        <button
          type="button"
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-[#BE202F] text-white text-base font-medium sm:col-start-2 sm:text-sm"
          onClick={() => recoverPassword()}
        >
          Aceptar
        </button>
        <button
          type="button"
          className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:col-start-1 sm:text-sm"
          onClick={() => setOpenForgotPassword(false)} // Cerrar el modal si el usuario cancela
        >
          Cancelar
        </button>
      </div>
    </>
  );*/

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setLoading(true);
    auth
      .signIn(user, password)
      .then((response) => {
        setLoading(false);
        navigate("/rides", {
          state: { isLogin: true },
        });
      })
      .catch((e) => {
        setLoading(false);
        setErrorMessage(e.detail);
      });
  };

  return (
    <div className="poppins-medium min-h-screen h-full flex justify-between items-center select-none">
      <div className="w-full md:w-3/5 items-center my-auto mx-auto">
        {/*<Modal
          size="sm:max-w-lg w-full"
          content={forgotPassword}
          open={openForgotPassword}
          setOpen={setOpenForgotPassword}
        />*/}
        <form
          className="flex flex-col space-y-6 w-[50%] my-auto mx-auto"
          onSubmit={handleSubmit}
        >
          <img
            className="w-[60px] h-[60px] mb-5"
            src={aquilaLogo}
            alt="Logo de Aquila"
          />
          <h1 className="poppins-bold text-4xl text-left text-[#1F384C] tracking-wider">
            Iniciá sesión
          </h1>
          <p className="poppins-medium text-sm text-left text-[#939CAA] tracking-wider">
            Ingresá el usuario y contraseña de tu cuenta
          </p>
          <CustomTextInput
            login
            type="text"
            placeholder="Usuario"
            value={user}
            onChange={(e) => setUser(e.target.value)}
            style={{ fontSize: 14 }}
          />
          <CustomTextInput
            login
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ fontSize: 14 }}
          />
          {errorMessage && (
            <div
              className="bg-red-100 mt-4 border border-red-400 text-red-700 px-4 py-3 rounded relative"
              role="alert"
            >
              <span className="block sm:inline">{errorMessage}</span>
            </div>
          )}
          {/*<div className="flex justify-end">
            <button
              type="button"
              onClick={() => setOpenForgotPassword(true)}
              className="text-xs text-[#595A5C] tracking-wider"
            >
              ¿Olvidaste tu contraseña?
            </button>
          </div>*/}
          <button
            type="submit"
            className="w-full flex justify-center py-3 px-5 border rounded-md shadow-sm text-sm text-white bg-[#BE202F]"
          >
            {loading ? (
              <div className="w-5 h-5 mx-5 border-b-2 border-white rounded-full animate-spin"></div>
            ) : (
              "Iniciar sesión"
            )}
          </button>
        </form>
      </div>
      <img
        className="hidden md:inline w-2/5 h-[90vh] m-5 rounded-xl object-cover"
        src={LoginBackground}
        alt="Fondo de Login"
      />
    </div>
  );
};

export default LoginPage;
